import React, { useCallback, useState } from "react";
import { ArrowRightIcon, Button, Dialog, SpinnerLoader, useWizardContext } from "@activecollab/components";
import BillingAddressForm from "~/components/Subscription/BillingPaymentMethod/BillingAddressForm";
import { showErrorToast } from "~/components/Toast";

const AddPaymentMethodFirstStep = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const { goNext } = useWizardContext();

  const onSubmit = useCallback(() => {
    //handle success
    if (goNext && isValid) {
      setIsLoading(false);
      goNext();
    }
  }, [goNext, isValid]);

  const startLoader = useCallback(() => {
    setTimeout(() => {
      setIsLoading(true);
    }, 0);
  }, []);

  const onError = useCallback(() => {
    setIsLoading(false);
    showErrorToast("Failed to update billing details");
  }, []);

  const isValidated = useCallback((e) => {
    setIsValid(e);
  }, []);

  return (
    <>
      <Dialog.Content>
        <BillingAddressForm
          onSubmit={onSubmit}
          isValidated={isValidated}
          shouldShowSuccessMessage={false}
          onError={onError}
        />
      </Dialog.Content>
      <Dialog.ContentDivider />
      <Dialog.Actions>
        {isLoading ? (
          <div
            className="tw-flex"
            data-testid="spinnerDiv"
          >
            <SpinnerLoader />
            <span className="tw-ml-2">Processing</span>
          </div>
        ) : (
          <Button
            type="submit"
            form="billing_address_form"
            disabled={!isValid}
            onClick={startLoader}
          >
            Continue
            <ArrowRightIcon />
          </Button>
        )}
      </Dialog.Actions>
    </>
  );
};

export default AddPaymentMethodFirstStep;
